module.exports = __webpack_public_path__ + "img/avatar.cdffb85b.svg";